import { useT } from '../context/LocaleContext';

export default function ConfirmBar({
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  busy = false,
}) {
  const t = useT();
  return (
    <div className="confirm-bar">
      <p>{message}</p>
      <div className="row-actions">
        <button type="button" className="ghost" onClick={onCancel} disabled={busy}>
          {cancelLabel || t('common.back')}
        </button>
        <button type="button" className="primary" onClick={onConfirm} disabled={busy}>
          {busy ? t('common.working') : confirmLabel || t('common.confirm')}
        </button>
      </div>
    </div>
  );
}
